import { query } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { DocumentType } from '../../models/documentType.model';
import { DocumentFilter } from '../models/DocumentFilter';
import { QueryOperators } from '../models/DocumentFilterAttribute';
import { DocumentQuery } from '../models/DocumentQuery';
import { debounceTime, map, tap } from 'rxjs/operators';
import { IPageInfo } from '../../base/interfaces/IPageInfo';
import { queryOperators } from '../values/operators';
import { AttributeField, DocumentFilterDto } from '../../models/filters/document-filter.dto';
import { MatDialog, MatDialogConfig, MatTabChangeEvent } from '@angular/material';
import { DownloadFile, ExportComponent } from '../../dialogs/export/export.component';
import { DocumentService } from '../services/document.service';
import { ExportType } from '../../models/export-type.model';
import { IOperationResult } from '../../base/interfaces/ioperation-result';
import { IExportResult } from '../../base/interfaces/IExportResult';
import { ExportColumn } from '../../models/export-column.model';
import { StandardAttributes } from '../attributes/date-attribute/standard-attribute';
import { TranslateService } from '@ngx-translate/core';
import { ExportParameters } from '../../models/export-parameters.model';
import { IDownloadResult } from '../../base/interfaces/IDownloadResult';
import { Observable, combineLatest } from 'rxjs';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { DocumentTypeService } from '../../services/document-type.service';
import { mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-document-filters',
  templateUrl: './document-filters.component.html',
  styleUrls: ['./document-filters.component.css']
})
export class DocumentFiltersComponent implements OnInit, OnChanges {
  @Input() isNew = true;
  @Input() pageInfo: IPageInfo;

  @Output() query = new EventEmitter<DocumentQuery>();
  @Output() newDocument = new EventEmitter<DocumentType>();
  @Output() loadingChange = new EventEmitter<boolean>();
  public form: FormGroup;
  public type: DocumentType;
  public useMandatory = false;
  private _query: DocumentQuery;
  public operators = queryOperators;
  private top = 25;

  constructor(
    public userService: UserService,
    private documentService: DocumentService,
    private typeService: DocumentTypeService,
    private translateService: TranslateService,
    private dialog: MatDialog) {
    this.form = new FormGroup({
      name: new FormControl(),
      sort: new FormControl('lastChange'),
      sortDesc: new FormControl(true),
      createdFrom: new FormControl(),
      createdTill: new FormControl(),
      justMe: new FormControl(false),
      userId: new FormControl(),
      attributes: new FormArray([])
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    
  }
  toggleSortDirection() {
    const sortControl = this.form.get('sortDesc');
    const currentValue = <Boolean>sortControl.value;
    sortControl.setValue(!currentValue);
  }
  ngOnInit() {
    this.form.valueChanges.pipe(debounceTime(400)).subscribe((filter: DocumentFilter) => {
      if (this.form.valid) {
        //this._query = new DocumentQuery(DocumentFilter.toQuery(filter), this.type.id, filter.sort, filter.sortDesc, null, 20);
        this._query = new DocumentQuery(DocumentFilterDto.Create(filter), this.type.id, filter.sort, filter.sortDesc, null, this.top);
        this.query.emit(this._query);
      }
    });

    this.form.get('justMe').valueChanges.subscribe((value: boolean) => {
      this.form.get('userId').setValue(value ? (this.userService.current.id) : null);
    });
  }
  reset(): void {
    this.form.get('name').setValue(null);
    this.form.get('justMe').setValue(false);
    this.form.get('createdFrom').setValue(null);
    this.form.get('createdTill').setValue(null);
    const attributes = <FormArray>this.form.get('attributes');
    for (let i = 0; i<attributes.length; i++) {
      attributes.at(i).get('value').setValue(null);
      attributes.at(i).get('min').setValue(null);
      attributes.at(i).get('max').setValue(null);
    }

    this.form.get('name').updateValueAndValidity();
  }
  onFilterTabChanged(event: MatTabChangeEvent) {
    this.reset();
    if(event.index == 0) { // quick filter        
    }
    else if (event.index == 1) {  // advanced filter
    }
  }  
  RefreshAttributes() {
    let currentAttributes: any[] = null;
    let attributes: any[] = null;
    if ( this.form.get('attributes').value) {
      currentAttributes = this.type.attributes;
      attributes = Object.assign({}, currentAttributes);
    }
    this.form.get('attributes').reset();
    const formAttributes: FormArray = new FormArray([]);
    if (this.type && this.type.attributes) {
      let i = 0;
      for (const attr of this.type.attributes) {
        const currentValue = currentAttributes.filter(f => f.attributeId === attr.id);
        let attValue = null;
        let attDisplayValue = null;
        if (currentValue && currentValue.length > 0) {
          attValue = currentValue[0].value;
          attDisplayValue = currentValue[0].displayValue;
        }
        const groupObject = {
          typeId: new FormControl(attr.typeId),
          typeCode: new FormControl(attr.code),
          attributeId: new FormControl(attr.id),
          name: new FormControl(attr.name),
          code: new FormControl(null),
          operator: new FormControl(null),
          value: new FormControl(attValue || null),
          displayValue: new FormControl(attDisplayValue || null),
          min: new FormControl(attValue || null),
          max: new FormControl(attValue || null)
        };
        if (attr.code === 'reference') {
          if(attr.referenceInfo){
            groupObject.code.setValue(attr.referenceInfo.queryId);
          }          
          groupObject.operator.setValue(QueryOperators.Eq);
        }
        const formGroup = new FormGroup(groupObject);
        formAttributes.push(formGroup);
        i++;
      }
    }
    this.form.setControl('attributes', formAttributes);
  }
  onTypeSelected(type: DocumentType) {
    this.type = type;
    this.RefreshAttributes();
  }
  getAttributeElement(index: number): FormControl {
    const array = <FormArray>this.form.get('attributes');
    return (<FormControl>array.at(index));
  }
  onNew() {
    this.newDocument.emit(this.type);
  }
  onRefresh() {
    const sort = this.form.get('sort').value;
    const sortDesc = this.form.get('sortDesc').value;
    //this._query = new DocumentQuery(DocumentFilter.toQuery(this.form.value), this.type.id, sort, sortDesc, null, 20);
    this._query = new DocumentQuery(DocumentFilterDto.Create(this.form.value), this.type.id, sort, sortDesc, null, 20);
    this.query.emit(this._query);
  }
  onPrevPage() {
    if (this._query) {
      const pageRes = this._query.prevPage();
      if (pageRes) {
        this.query.emit(this._query);
      }
    }
  }
  onNextPage() {
    if (this._query) {
      const pageRes = this._query.nextPage();
      if (pageRes) {
        this.query.emit(this._query);
      }
    }
  }
  clearDate(evt: MouseEvent, controlName: string) {
    this.form.get(controlName).setValue(null);
    evt.stopPropagation();
  }
  getColumns(): ExportColumn[] {
    const ret: ExportColumn[] = [];
    ret.push(new ExportColumn(StandardAttributes.Name,this.translateService.instant('dws.documentName')));
    ret.push(new ExportColumn(StandardAttributes.Description,this.translateService.instant('dws.description')));    
    if(this.type && this.type.attributes) {
      for(let a=0;a<this.type.attributes.length;a++) {
        ret.push(new ExportColumn(this.type.attributes[a].id,this.type.attributes[a].name));
      }
    }
    return ret;
  }
  onExport() {

    this.documentService.getExportTypes(this.type.systemCode).subscribe(types => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        title: 'dialogs.export',
        type: 'document',
        options: types,
        columns: this.getColumns()
      };
      const dialogRef = this.dialog.open(ExportComponent, dialogConfig);
      return dialogRef.afterClosed().subscribe((result: ExportParameters) => {        
        if (result) {
          const filter = <DocumentFilterDto>Object.assign({}, this._query.filter);
          const attributes:AttributeField[] = [];
          if(result.columns) {
            result.columns.forEach(col => {
              if(col.enabled) {
                attributes.push(new AttributeField(col.key, col.name));
              }
            });
            filter.attributes = attributes;
          }
          this.loadingChange.emit(true);
          this.documentService.export(this._query.typeId, result.type.code, filter,
            0, 1000, this._query.sort, this._query.sortDesc).subscribe((result:IDownloadResult) => {
              if (result && result.export && result.export.link) {
                this.loadingChange.emit(false);
                DownloadFile(result.export.link, this.type.name);
                this.documentService.DeleteFile(result.export).subscribe();
              }
            }, (err) => {
            })  
        }
      });   
    });
  }
  private ConrimRecreate(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dws.dialogMessages.recreateIndex'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  onReindex(){
    if (this.type.id) {
      this.ConrimRecreate(this.type.code).subscribe((ret) => {
        const reindexPageSize = 20;
        if (ret) {
          this.typeService.recreateIndex(this.type.id).subscribe(() => {
            this.documentService.Filter(`typeId eq ${this.type.id}`,null,null,1,reindexPageSize).pipe(mergeMap(initalData => {
              const pageCount = initalData.pageInfo.pageCount;            
              const result:Observable<any>[] = [];
              for(let p=1;p<=pageCount;p++){

                this.documentService.Filter(`typeId eq ${this.type.id}`,null,null,p,reindexPageSize).subscribe(data => {
                  if(data && data.payload) {
                    let ids:string[] = data.payload.map(item => item.id);
                    let pageResult = this.documentService.reindex(ids);
                    pageResult.subscribe();
                    result.push(pageResult);
                  }
                });                
              }                          
              return combineLatest(result);
            })).subscribe();
          });
        }
      });
    }
  }
}